<template>
  <RouterView />
</template>

<script setup lang="ts">
import { computed, provide } from "vue";
import { HAPTICS_KEY } from "@discover/components";
import { usePersistStore } from "@shared/store/persist";

const persistStore = usePersistStore();

provide(HAPTICS_KEY, {
  isEnabled: computed(() => persistStore.persist.haptics),
});
</script>
